import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import * as reducks from '../../../reducks'
import * as urls from '../../../lib/urls'

const ConfirmRegisterEmailReceiveContainer = () => {
  const dispatch = useDispatch()

  const strQueries = urls.useQuery(useLocation)

  const queries = {
    confirmToken: strQueries.get('confirm_token'),
    id: strQueries.get('id')
  }

  useEffect(() => {
    dispatch(
      reducks.resources.users.actions.confirmUserEmail(
        queries.id,
        queries.confirmToken
      )
    )
  }, [])

  return <div />
}

export default ConfirmRegisterEmailReceiveContainer
